import { render } from "./vcommonproblemadd.vue?vue&type=template&id=433c6da1&scoped=true"
import script from "./vcommonproblemadd.vue?vue&type=script&lang=js"
export * from "./vcommonproblemadd.vue?vue&type=script&lang=js"

import "./vcommonproblemadd.vue?vue&type=style&index=0&id=433c6da1&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-433c6da1"]])

export default __exports__